// extracted by mini-css-extract-plugin
export default {"wrap":"iG-z","fullWidth":"jG-z","hideOnDesktop":"kG-z","content":"lG-z","hasOpenedNav":"mG-z","crumbsList":"nG-z","dropdownsWrap":"oG-z"};